import React, { useEffect, useState } from "react";
import { EaseDrawer } from "../../../libs/EaseDrawer";
import { Text1, Text4 } from "../../../styles";
import { Descriptions, Button, Icon, Collapse, Table, Badge, Popover } from "antd";
import moment from "moment"
import { EaseTable } from "../../../libs/EaseTable";
import { Merchant } from "../../../models";
import { PaginationKaBaap } from "../../Common";
import { handleApiExceptions } from "../../../app_methods";

const { Panel } = Collapse

const PG_TRANSACTION_STATUS_TYPES = {
    preinitiated: {
        label: "In Process",
        color: "blue"
    },
    initiated: {
        label: "In Process",
        color: "blue",
    },
    pending: {
        label: "Pending",
        color: "yellow",
    },
    success: {
        label: "Success",
        color: "green",
    },
    userCancelled: {
        label: "Cancelled",
        color: "red",
    },
    failure: {
        label: "Failed",
        color: "red"
    },
    dropped: {
        label: "Dropped",
        color: "red",
    },
    bounced: {
        label: "Bounced",
        color: "yellow",
    },
}

const TransactionHistoryDrawer = (props) => {
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [transactionHistory, setTransationHistory] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [tableFilters, setTableFilters] = useState({});
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });

    const renderTitle = () => {
        return (
            <div className="mt-4 mb-2">
                <Text1 className="d-block" strong>Transaction History</Text1>
            </div>
        )
    };

    const fetchPGTransactionHistory = async (_pagination = pagination, _filters = tableFilters) => {
        setIsTableLoading(true)
        const merchant = new Merchant()
        let response = await merchant.view_pg_transaction_history({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters })
        if (!response.success) {
            setIsTableLoading(false)
            handleApiExceptions(response);
            return;
        }
        setIsTableLoading(false)
        setTransationHistory(response.data.results)
        setPagination({ ..._pagination, ...response.data.pagination })
    }

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchPGTransactionHistory({ ..._pagination })
    }

    const onCLose = () => {
        setPagination({ ...pagination, current: 1 });
        props.toggleTransactionHistoryDrawer()
        setTableFilters({})
    }

    const getTransactionHistoryTableColumns = [
        {
            title: "Transaction date",
            key: "transaction_date",
            render: (record) => <Text4>{record.transaction_date ? moment(record.transaction_date).format('MMMM Do YYYY, h:mm:ss a') : "---"}</Text4>
        },
        {
            title: "Transaction ID",
            key: "transaction_id",
            render: (record) => <Text4>{record.transaction_id}</Text4>
        }, {
            title: "Amount",
            key: "amount",
            render: (record) => <Text4>₹ {record.amount}/-</Text4>
        }, {
            title: "Status",
            key: "status",
            render: (record) =>
                <div>
                    <Badge color={PG_TRANSACTION_STATUS_TYPES[record.status].color} text={<Text4>{PG_TRANSACTION_STATUS_TYPES[record.status].label}</Text4>} />
                </div>
        }
    ];

    const pgTransactionHistoryFilters = [{
        label: "Status",
        field: "status",
        placeholder: "Select Status",
        inputType: "select",
        defaultValue: undefined,
        options: [{
            key: "1",
            value: "pending",
            label: <Badge color="yellow" text={<Text4>Pending</Text4>} />
        }, {
            key: "2",
            value: "success",
            label: <Badge color="green" text={<Text4>Success</Text4>} />
        },{
            key: "3",
            value: "failure",
            label: <Badge color="red" text={<Text4>Failed</Text4>} />
        },{
            key: "4",
            value: "userCancelled",
            label: <Badge color="red" text={<Text4>Cancelled</Text4>} />
        },{
            key: "5",
            value: "dropped",
            label: <Badge color="red" text={<Text4>Dropped</Text4>} />
        },{
            key: "6",
            value: "bounced",
            label: <Badge color="yellow" text={<Text4>Bounced</Text4>} />
        },{
            key: "7",
            value: "initiated",
            label: <Badge color="blue" text={<Text4>In Process</Text4>} />
        }]
    }, {
        label: "Transaction ID",
        field: "transaction_id",
        placeholder: "Enter Transaction ID",
        inputType: "text",
        defaultValue: undefined
    }]

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setTableFilters(tableInfo.filters);
        fetchPGTransactionHistory(_pagination, tableInfo.filters);
    }


    useEffect(() => {
        if (props.visible) {
            setTableFilters(tableFilters)
            setTableColumns(getTransactionHistoryTableColumns);
            fetchPGTransactionHistory({ ...pagination }, { ...tableFilters });
        }
    }, [props.visible]);

    return (
        <>
            <EaseDrawer
                className="user-details-wrapper"
                title={false}
                width={800}
                visible={props.visible}
                onClose={onCLose}
                centered
                hideHeader
                hideFooter
                destroyOnClose
            >
                <div>
                    {renderTitle()}
                    <EaseTable
                        className="transaction-history-table-wrapper"
                        loading={isTableLoading}
                        data={transactionHistory}
                        columns={tableColumns}
                        filterNodes={pgTransactionHistoryFilters}
                        handleTableChange={handleTableChange}
                    />
                    <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
                </div>
            </EaseDrawer>
        </>
    )
};

export { TransactionHistoryDrawer };